/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useCallback } from 'react';
import { eventPath } from '../../utils/eventPath';
export function useClickOutside(ref, callback) {
  var subscribe = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  var handleClick = useCallback(function (event) {
    var target = event.target.shadowRoot ? eventPath(event)[0] : event.target;

    if (ref.current && !ref.current.contains(target)) {
      callback(target);
    }
  }, [ref, callback]);
  useEffect(function () {
    /* istanbul ignore next */
    if (typeof document === 'undefined') {
      return null;
    }

    if (subscribe) {
      document.addEventListener('mousedown', handleClick);
      document.addEventListener('touchstart', handleClick);
    } else {
      document.removeEventListener('mousedown', handleClick);
      document.removeEventListener('touchstart', handleClick);
    }
  }, [subscribe, handleClick]);
  useEffect(function () {
    return function () {
      document.removeEventListener('mousedown', handleClick);
      document.removeEventListener('touchstart', handleClick);
    };
  }, [handleClick]);
  return {
    handleClick: handleClick
  };
}